// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_p9-0";
export var animationContainer = "_p9-1";
export var itemPrice = "_p9-a";
export var itemizedContent = "_p9-9";
export var itemizedHeader = "_p9-7";
export var itemizedRow = "_p9-8";
export var itemizedSection = "_p9-6";
export var modalContent = "_p9-2";
export var orderName = "_p9-3";
export var refundOption = "_p9-4";
export var refundOptionsContainer = "_p9-5";
export var shippingLabel = "_p9-b";
export var totalRow = "_p9-c";